import React, { useEffect, useState } from "react";
import { countries as originalCountries } from './countries';

const actions = [
    "just deposited",
    "completed tasks and earned",
    "earned with referral commission",
    "just withdrew",
];

const countries = [...originalCountries, 
    { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" },
    { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" },
    { name: "United States", flag: "https://flagcdn.com/48x36/us.png" },
    { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" },
    { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" },
    { name: "USA", flag: "https://flagcdn.com/48x36/us.png" },
    { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" }
];

const generateUserID = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};

const formatNumber = (num) => num.toLocaleString(); 

const generateRandomTransaction = (forceTanzania = false) => {
    const userId = generateUserID();
    let country;
    
    if (forceTanzania) {
        country = { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" };
    } else {
        country = countries[Math.floor(Math.random() * countries.length)];
    }
    
    const action = actions[Math.floor(Math.random() * actions.length)];
    const amountUXB = Math.floor(Math.random() * 500) + 1;
    const amountTZS = amountUXB * 2500;

    return {
        id: userId,
        country: country.name,
        flag: country.flag,
        action,
        amountUXB: formatNumber(amountUXB),
        amountTZS: formatNumber(amountTZS),
    };
};

const LiveBoard = () => {
    const [transactions, setTransactions] = useState([]);
    const [onlineUsers, setOnlineUsers] = useState(5_500_000);

    useEffect(() => {
        let lastTanzaniaTime = Date.now(); 

        const addTransaction = () => {
            const now = Date.now();
            let forceTanzania = false;

            if (now - lastTanzaniaTime > 5000) {
                forceTanzania = true;
                lastTanzaniaTime = now;
            }

            setTransactions((prev) => {
                const newTransaction = generateRandomTransaction(forceTanzania);
                return [...prev.slice(-10), newTransaction];
            });

            const randomTime = Math.random() * (3 - 2) + 1;
            setTimeout(addTransaction, randomTime * 1000);
        };

        addTransaction();

        const tanzaniaInterval = setInterval(() => {
            const tanzaniaCount = Math.floor(Math.random() * 3) + 1;
            for (let i = 0; i < tanzaniaCount; i++) {
                setTimeout(() => {
                    setTransactions((prev) => {
                        const newTransaction = generateRandomTransaction(true);
                        return [...prev.slice(-10), newTransaction];
                    });
                }, i * 1000);
            }
        }, Math.random() * (7000 - 6000) + 6000);

        const onlineUsersInterval = setInterval(() => {
            setOnlineUsers((prev) => {
                const change = Math.floor(Math.random() * 20000 - 10000);
                let newCount = prev + change;
                if (newCount < 5_000_000) newCount = 5_000_000;
                if (newCount > 10_000_000) newCount = 10_000_000;
                return newCount;
            });
        }, 100);

        return () => {
            clearInterval(onlineUsersInterval);
            clearInterval(tanzaniaInterval);
        };
    }, []);

    return (
        <div className="flex flex-col gap-1 w-full my-2">
            <div className="flex w-full justify-between items-center p-2">
                <div className="text-[18px] font-bold text-red-500">Live board</div>
                <div className="text-[14px]">{formatNumber(onlineUsers)} People online</div>
            </div>
            <div className="flex flex-col overflow-y-auto scrollbar-hide bg-zinc-100 items-center w-full p-2 gap-2">
                {transactions.map((txn, index) => (
                    <div
                        key={txn.id}
                        className="flex gap-4 w-full bg-white rounded-[12px] p-2 items-center transaction"
                        style={{
                            animation: `fadeIn 0.5s ease-in-out ${index * 0.1}s, moveUp 0.5s ease-out ${index * 0.1}s`
                        }} // Staggered animation
                    >
                        <img src={txn.flag} alt={txn.country} className="rounded-full object-cover h-[40px] w-[40px] shrink-0" />
                        <div className="text-[14px] line-clamp-2 w-full leading-[1]">
                            {txn.id} a user from {txn.country} {txn.action} {txn.amountUXB} Uxbroot (UXB) | Tzs {txn.amountTZS}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LiveBoard;
